<template>
  <v-row dense>
    <v-col>
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ isNew ? "Створення бонусу" : "Бонус" }}
          </h1>
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col
                cols="3"
                class="pb-0"
              >
                <DatePicker
                  v-model="date"
                  default-value
                  :filled="false"
                  label="Дата*"
                  :error-messages="$v.date.$error ? errors.DATE : []"
                  :hide-details="false"
                  @input="$v.date.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0 mt-n4">
                <ClientSelect
                  v-model="client"
                  :client-id="client && client.id"
                  label="Клієнт*"
                  :error-messages="$v.client.title.$error ? errors.CLIENT : []"
                  :hide-details="false"
                  @change="changeClient"
                  @input="$v.client.$touch()"
                />
              </v-col>
              <v-col class="pb-0 mt-n4">
                <ProjectSelect
                  v-model="project"
                  :client-id="clientId"
                  @input="isChanged = true"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pb-0 mt-n4">
                <DecimalEditor
                  v-model="hours"
                  label="Бонуснi години*"
                  :scale="2"
                  :error-messages="$v.hours.$error ? errors.HOURS : []"
                  :hide-details="false"
                  @input="$v.hours.$touch()"
                />
              </v-col>
              <v-col class="pb-0 mt-n4">
                <DecimalEditor
                  v-model="amount"
                  label="Сума бонуса"
                  required
                  :scale="2"
                  :error-messages="$v.amount.$error ? errors.AMOUNT : []"
                  :hide-details="false"
                  @input="$v.amount.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pb-0 mt-n4">
                <CustomTextField
                  v-model="comments"
                  label="Примітки"
                  required
                  :error-messages="$v.comments.$error ? errors.COMMENTS : []"
                  :hide-details="false"
                  @input="$v.comments.$touch()"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pt-0">
            <PrimaryBtn
              :has-warnings="$v.$invalid"
              :loading="loading"
              @click="save"
            />
            <v-btn @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientSelect from "@/components/selects/ClientSelect";
import ProjectSelect from "../../catalogs/projects/ProjectSelect";
import DecimalEditor from "../../../components/DecimalEditor";
import DatePicker from "@/components/story/DatePicker";
import * as bonusesApi from "../../../backend/bonusesApi.js";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    ClientSelect,
    ProjectSelect,
    DecimalEditor,
    DatePicker,
    PrimaryBtn,
  },

  props: ["id"],
  data: () => ({
    dateMenu: false,
    date: "",
    clients: [],
    client: null,
    projects: [],
    project: null,
    hours: "",
    amount: "",
    comments: "",
    loading: false,
    isChanged: false,
  }),

  validations: {
    client: {
      id: { required },
      title: { required },
    },
    date: {
      required,
    },
    amount: {
      required,
    },
    hours: {
      required,
    },
    comments: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    formattedDate() {
      return this.date ? this.moment(this.date).format("DD.MM.YYYY") : "";
    },
    clientId() {
      return this.client ? this.client.id : null;
    },
    errors() {
      return {
        CLIENT: [ERRORS.REQUIRED],
        DATE: [ERRORS.REQUIRED],
        HOURS: [ERRORS.REQUIRED],
        AMOUNT: [ERRORS.REQUIRED],
        COMMENTS: [ERRORS.COMMENTS],
      };
    },
  },
  created() {
    if (+this.id) {
      bonusesApi.getBonus(this.id).then((bonus) => {
        this.date = bonus.date;
        this.amount = bonus.amount;
        this.comments = bonus.comments;
        if (bonus.hours === 0) {
          this.hours = "";
        } else {
          this.hours = bonus.hours;
        }
        this.client = bonus.client;
        this.clients.push(this.client);

        if (bonus.project != null) {
          this.project = bonus.project;
          this.projects.push(this.project);
        }
      });
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;

      const bonus = {
        clientId: this.client.id,
        date: this.date,
        amount: this.amount,
        comments: this.comments,
      };
      if (this.hours === "") {
        bonus.hours = 0;
      } else {
        bonus.hours = this.hours;
      }
      if (this.project != null) {
        bonus.projectId = this.project.id;
      }

      try {
        if (!this.isNew) {
          await bonusesApi
            .updateBonus(this.id, bonus);
        } else {
          await bonusesApi
            .createBonus(bonus);
        }
        this.$notifySuccess();
        this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
    changeClient() {
      this.isChanged = true;
      this.project = null;
    },
  },
};
</script>
